import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getResellerList({
    endDate,
    limit,
    page,
    q,
    reseller_type,
    startDate,
    status,
  }) {
    const params = {
      application_status: status,
      cursor: page,
      end_date: endDate,
      limit,
      q,
      reseller_type,
      start_date: startDate,
    };
    const url = '/resellers';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getResellerDetail(id) {
    return api.get(`/resellers/${id}`);
  },
  getResellerCashback({ id, cursor, limit }) {
    return api.get(`/resellers/${id}/wallet?cursor=${cursor}&limit=${limit}`);
  },
  getResellerOrder({ id, cursor, limit, order_status }) {
    const params = {
      cursor,
      limit,
      'statuses[]': order_status,
    };
    const url = `/resellers/${id}/orders`;
    return api.get(url, { params });
  },
  acceptReseller(id, type) {
    return api.post(`/resellers/${id}/accept`, { reseller_type: type });
  },
  rejectReseller(id, rejectReason) {
    return api.post(`/resellers/${id}/reject`, { message: rejectReason });
  },
  getAllOrder({ page, q, status, startDate, endDate }) {
    const params = {
      'statuses[]': status,
      cursor: page,
      end_date: endDate,
      limit: 10,
      q,
      start_date: startDate,
    };
    const url = '/resellers/referral_orders';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getAllCashback({ page, startDate, endDate }) {
    const params = {
      cursor: page,
      end_date: endDate,
      limit: 10,
      start_date: startDate,
    };
    const url = '/resellers/cashback_activities';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getAllWithdrawal({ page, startDate, endDate, withdrawal_status }) {
    const params = {
      cursor: page,
      end_date: endDate,
      limit: 10,
      start_date: startDate,
      withdrawal_status,
    };
    const url = '/resellers/withdrawal_activities';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getGlobalWithdrawalReport({ end_date, start_date, withdrawal_status }) {
    const params = {
      end_date,
      start_date,
      withdrawal_status,
    };
    const url = '/resellers/withdrawal_report';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getWithdrawalReport(id, { withdrawal_status }) {
    const params = {
      withdrawal_status,
    };
    const url = `/resellers/${id}/withdrawal_report`;
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getGlobalOrderReport({ end_date, order_status, q, start_date }) {
    const params = {
      end_date,
      q,
      start_date,
      'statuses[]': order_status,
    };
    const url = `/resellers/referral_order_report`;
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getOrderReport(id, { statuses }) {
    const params = {
      'statuses[]': statuses,
    };
    const url = `/resellers/${id}/referral_order_report`;
    return api.get(url, { params: omitBy(params, isNil) });
  },
  getResellerWithdrawal({ id, page = 1, withdrawal_status }) {
    const params = {
      cursor: page,
      limit: 5,
      withdrawal_status,
    };
    const url = `/resellers/${id}/wallet`;
    return api.get(url, { params: omitBy(params, isNil) });
  },

  getPageDetail() {
    return api.get(`/resellers/page`);
  },
  getResellerTypes() {
    return api.get(`/resellers/types`);
  },
  createPageDetail(payload) {
    return api.post(`/resellers/page`, { business_page: payload });
  },
  updateResellerCashback(payload) {
    return api.post(`/resellers/update_type`, { reseller_types: payload });
  },
  updateResellerCode(id, code) {
    return api.put(`/resellers/${id}/update_referral_code`, {
      referral_code: code,
    });
  },
};
